import { cn } from "../lib/cn";
import { CallSketch, SB_MONO } from "./CallSketch";

/**
 * Features, "Pull requests, live.": Maya asks where Jon's fix is up to, and the pull request pops up, as the
 * product draws a pr_status card (title, #number · repo, review status).
 */
export const PR_SKETCH = {
  speaker: "Maya",
  said: "Where's the checkout fix up to? I can't find the PR.",
  title: "Retry payment calls with backoff",
  where: "#482 · acme/checkout",
  status: "review",
} as const;

export function PrCardSketch() {
  return (
    <CallSketch speaker={PR_SKETCH.speaker} said={PR_SKETCH.said} app="github" label="Pull Request">
      <p className="text-[11px] font-semibold leading-tight">{PR_SKETCH.title}</p>
      <p className={cn("mt-0.5 text-[8px] leading-snug text-[#94A3B8]", SB_MONO)}>{PR_SKETCH.where}</p>
      <span
        className={cn(
          "mt-1 inline-block rounded border border-[rgba(59,130,246,0.22)] bg-[rgba(59,130,246,0.10)] px-1.5 py-px text-[8.5px] text-[#3B82F6]",
          SB_MONO,
        )}
      >
        {PR_SKETCH.status}
      </span>
    </CallSketch>
  );
}
